// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3AQcY","inner":"style_inner__3YviV","bottom":"style_bottom__iVaRC","copyright":"style_copyright__3MW7p"};